import {
  CONTENT_POINT_PROFICIENCY_COMMUNICATING,
  CONTENT_POINT_PROFICIENCY_UNDERSTANDING,
  CONTENT_POINT_PROFICIENCY_FLUENCY,
  CONTENT_POINT_PROFICIENCY_REASONING,
  CONTENT_POINT_PROFICIENCY_PROBLEM_SOLVING,
  ContentPointProficiencies,
} from 'global/constants';
import { ActivityOutcomeGroup } from '../activity-outcomes.constants';

export type ContentPoint = {
  id: number;
  name: string;
  content: string;
};

export type ActivityOutcomeGroupEdit = Omit<
  ActivityOutcomeGroup,
  '__typename' | 'id' | 'outcome' | 'contentPoints'
> & {
  contentPointIds: number[];
};

export const PROFICIENCIES = [
  {
    label: 'Communicating',
    value: CONTENT_POINT_PROFICIENCY_COMMUNICATING as ContentPointProficiencies,
  },
  {
    label: 'Fluency',
    value: CONTENT_POINT_PROFICIENCY_FLUENCY as ContentPointProficiencies,
  },
  {
    label: 'Problem-solving',
    value:
      CONTENT_POINT_PROFICIENCY_PROBLEM_SOLVING as ContentPointProficiencies,
  },
  {
    label: 'Reasoning',
    value: CONTENT_POINT_PROFICIENCY_REASONING as ContentPointProficiencies,
  },
  {
    label: 'Understanding',
    value: CONTENT_POINT_PROFICIENCY_UNDERSTANDING as ContentPointProficiencies,
  },
];
